<template lang="pug">
site-list(
    platformType="web"
    :sites="sites"
    :isRemainingSites="isRemainingSites"
    :deletingErrors="deletingErrors"
    :filters="filters"
    @update-status="updateStatus"
    @update-search-string="updateSearchString"
    @more-sites="moreSites"
    @close-error-popup="closeErrorPopup"
)
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import siteList from '@/components/site_elements/SiteList.vue'

export default {
    name: 'Sites',
    components: {
        siteList,
    },
    data() {
        return {
            filterProccessing: false,
            filters: {
                status: 'all',
                searchString: '',
            },
        }
    },
    computed: {
        ...mapGetters('Placement', ['deletingErrors']),
        ...mapGetters('Sites', [
            'sites',
            'isRemainingSites',
            'isFetchingSites',
        ]),
        ...mapGetters('Refbooks', ['refbooksLoaded']),
        lastSiteId() {
            if (this.sites.length > 0) {
                return this.sites[this.sites.length - 1].site_id
            } else {
                return 0
            }
        },
    },
    methods: {
        ...mapActions('Sites', ['fetchSites', 'cleanSites']),
        ...mapActions('Placement', ['cleanError']),

        moreSites() {
            this.fetchSites({
                lastSiteId: this.lastSiteId,
                status: this.filters.status,
                searchString: this.filters.searchString,
                platformType: 'web',
            })
        },
        closeErrorPopup() {
            this.cleanError()
        },
        updateStatus(value) {
            this.cleanSites()
            this.filters.status = value
            this.fetchSites({
                lastSiteId: this.lastSiteId,
                status: this.filters.status,
                searchString: this.filters.searchString,
                platformType: 'web',
            })
        },
        updateSearchString(value) {
            this.filters.searchString = value
            if (!this.filterProccessing) {
                this.filterProccessing = true
            }
        },
    },
    watch: {
        filterProccessing(newVal) {
            if (newVal) {
                setTimeout(() => (this.filterProccessing = false), 2000)
            } else {
                this.cleanSites()
                this.fetchSites({
                    lastSiteId: this.lastSiteId,
                    status: this.filters.status,
                    searchString: this.filters.searchString,
                    platformType: 'web',
                })
            }
        },
        refbooksLoaded: {
            handler: function (newVal) {
                if (newVal && !this.isFetchingSites) {
                    this.fetchSites({
                        lastSiteId: 0,
                        status: '',
                        searchString: '',
                        platformType: 'web',
                    })
                }
            },
            immediate: true,
        },
    },
}
</script>

<style scoped lang="stylus"></style>
